/**
 * Version applicative — clippit-avv frontend.
 * Historique :
 *   - 1.0.0 — Version initiale (suivi des avant-ventes, listes déroulantes et
 *             champs personnalisés gérables par l'admin, sync utilisateurs Entra ID).
 */
export const APP_VERSION = '1.0.0';
